import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { APP_ROUTES } from "../../../PageRouting/approutes";
import Layouts from "../../Layouts";
import SlotService from "../../../Services/SlotService";
import dayjs from "dayjs";
import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Row,
  Select,
  Switch,
  TimePicker,
} from "antd";
import { useForm } from "antd/es/form/Form";
import CommonFunctions from "../../Shared/CommonFunctions";
import DoctorService from "../../../Services/DoctorService";
import ConsultationService from "../../../Services/ConsultationService";
import { LiaToggleOnSolid } from "react-icons/lia"; // <LiaToggleOnSolid />
import { LiaToggleOffSolid } from "react-icons/lia"; // <LiaToggleOffSolid />
import PatientService from "../../../Services/PatientService";
import PatientQueue from "../VCPage/PatientQueue";
import { MdKeyboardDoubleArrowUp } from "react-icons/md";
import Draggable from "react-draggable";
import patientqueue from "../../../Assets/Images/Svg/queue2.svg";
import { IoIosCloseCircle } from "react-icons/io";

function Slot() {
  const [loading, setLoading] = useState(false);
  const [savedSlots, setSavedSlots] = useState([]);
  const [days, setDays] = useState([]);
  const [form, setForm] = useForm();
  const [hospitalAccountData, setHospitalAccountData] = useState(null);
  const [clinicDetails, setClinicDetails] = useState(null);
  const durationArr = [5, 10, 15, 20, 30, 40, 50, 60];
  const [isChecked, setIsChecked] = useState(false);
  const [appointmentTypes, setAppointmentTypes] = useState([
    "inPerson",
    "video",
  ]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const history = useHistory();
  const storedLoginResult = localStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;


  const handleToggle = () => {
    setIsChecked(!isChecked);
  };

  const getSlotDetails = async () => {
    setLoading(true);

    let payload = {
      userId: loginResultObject.user.userId,
      clinic_Id: loginResultObject.user.clinic_Id,
      status: 1,
    };


    try {
      let result = await SlotService.GetSlotDetails(payload);
      if (result.data) {
        setSavedSlots(result.data);
      }
      setLoading(false);
    } catch (error) {
      message.error("error Loading Slots please Try again");
      history.push(APP_ROUTES.APPOINTMENTS);
    }
  };

  const handleDays = (checkedDays) => {
    const isSelectedAll = checkedDays?.includes("all");
    const allDays = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];
    if (!days.includes("all") && checkedDays.includes("all")) {
      setDays([...allDays, "all"]);
    } else if (
      days.includes("all") &&
      isSelectedAll &&
      checkedDays.length - 1 < 7
    ) {
      const filtered = checkedDays.filter((item) => item !== "all");
      setDays(filtered);
    } else if (!days.includes("all") && checkedDays.length < 7) {
      setDays(checkedDays);
    } else if (!isSelectedAll) {
      if (checkedDays.length === 7 && days.length > 7) {
        setDays([]);
      } else {
        setDays([...allDays, "all"]);
      }
    } else if (!checkedDays?.includes("all")) {
      setDays([]);
    }
  };

  const fetchHospitalData = async (id) => {
    const response = await DoctorService.getHospitalAccountData(id);
    setHospitalAccountData(response.data[0]);
  };

  const fetchClinicData = async (AccId) => {
    const response = await ConsultationService.getClinicData(AccId);
    setClinicDetails(response.data[0]);
  };

  const saveSlot = async (payload) => {
    setLoading(true);
    let data = {
      accountName: hospitalAccountData.account_Name,
      clinicName: clinicDetails.clinic_Name,
      account_Id: loginResultObject.user.account_Id,
      clinic_Id: loginResultObject.user.clinic_Id,
      consultationDuration: payload.duration,
      createdBy: `Dr. ${loginResultObject.user?.firstName} ${loginResultObject.user?.lastName}`,
      createdDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      fromDate: dayjs(payload.fromdate).format("MM/DD/YYYY"),
      fromTime: dayjs(payload.fromtime).format("HH:mm"),
      inPerson: appointmentTypes.includes("inPerson") ? "Y" : "N",
      inpersonFee: payload.inpersonFee,
      homeVisitFee: payload.homeVisitFee,
      modifiedBy: `Dr. ${loginResultObject.user?.firstName} ${loginResultObject.user?.lastName}`,
      modifiedDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      publicHolidays: "",
      status: 1,
      toDate: dayjs(payload.todate).format("MM/DD/YYYY"),
      toTime: dayjs(payload.totime).format("HH:mm"),
      userId: loginResultObject.user.userId,
      userName: `Dr. ${loginResultObject.user?.firstName} ${loginResultObject.user?.lastName}`,
      video: appointmentTypes.includes("video") ? "Y" : "N",
      videoFee: loginResultObject.user.videoFee,

      sunday: days.includes("sunday") ? "Y" : "N",
      monday: days.includes("monday") ? "Y" : "N",
      tuesday: days.includes("tuesday") ? "Y" : "N",
      wednesday: days.includes("wednesday") ? "Y" : "N",
      thursday: days.includes("thursday") ? "Y" : "N",
      friday: days.includes("friday") ? "Y" : "N",
      saturday: days.includes("saturday") ? "Y" : "N",
    };

    try {
      let result = await SlotService.SaveSlot(data);
      if (result.data == 1) {
        form.resetFields();
        getSlotDetails();
        setDays([]);
        setLoading(false);
        message.success("Slots published Successfully");
      }
    } catch (e) {
      e && message.error(e.response.data.message);
      setLoading(false);
    }
  };

  const makeSlotInactive = async (slot) => {
    setLoading(true);

    try {
      let result = await SlotService.InActiveSlots(slot.id);
      getSlotDetails();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    fetchHospitalData(loginResultObject.user.account_Id);
    fetchClinicData(loginResultObject.user.clinic_Id);
    getSlotDetails();
  }, []);

  const handleConsType = (checkedValues) => {
    setAppointmentTypes(checkedValues);
  };

  const onClose = () => {
    setIsDrawerOpen(false);
  };

  const showDrawer = () => {
    setIsDrawerOpen(true);
  };

  const [isVerticalOpen, setIsVerticalOpen] = useState(true);
  const handleClick = () => {
    setIsVerticalOpen(true);
  };
  const closeCircle = () => {
    setIsVerticalOpen(false);
  };

  return (
    <Layouts>
      {loading && (
        <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="spinner"></div>
        </div>
      )}
      <div className="">
        <div className="flex justify-between items-center ">
          <div className="font-sans font-semibold text-[#333333] text-base">
            Create Slot
          </div>
          <div className="flex gap-2">
            {/* <button
              onClick={() => {
                history.push(APP_ROUTES.APPOINTMENTS);
              }}
              className="p-2 rounded-md text-white w-40 border-white border"
            >
              Appointments
            </button> */}
          </div>
        </div>

        <div className=" ">
          <div className=" ">
            <div className="shadow-[0_0_10px_rgba(0,0,0,0.15)]  mt-2">
              <div className=" p-1 ">
                <Form
                  className="formDesign patientForm mt-3 mb-3"
                  name="basic"
                  layout="vertical"
                  autoComplete="off"
                  form={form}
                  onFinish={saveSlot}
                  initialValues={{
                    videoFee: loginResultObject.user.videoFee,
                    inpersonFee: loginResultObject.user.inpersonFee,
                    // homeVisitFee: loginResultObject.user.homeVisitFee,
                  }}
                >
                  <div className="flex flex-wrap gap-4  p-2">
                    <div className="">
                      <Form.Item name="fromdate">
                        <DatePicker
                          placeholder="Start date"
                          format="DD/MM/YYYY"
                          className="w-[202px] md:h-12 h-8 "
                          disabledDate={(current) =>
                            current && current < dayjs().startOf("day")
                          }
                        />
                      </Form.Item>
                    </div>

                    <div className="">
                      <Form.Item name="todate">
                        <DatePicker
                          placeholder="End date"
                          format="DD/MM/YYYY"
                          className="w-[202px] md:h-12 h-8 "
                          disabledDate={(current) =>
                            current &&
                            current < dayjs().add(1, "day").startOf("day")
                          }
                        />
                      </Form.Item>
                    </div>

                    <div className="">
                      <Form.Item name="fromtime">
                        <TimePicker
                          className="w-[202px] md:h-12 h-8 "
                          placeholder="Start time"
                          format="h:mm A"
                          minuteStep={10}
                          needConfirm={false}
                          showNow={false}
                          // disabledTime={disabledTime}
                          allowClear={false}
                          inputReadOnly={true}
                        />
                      </Form.Item>
                    </div>

                    <div className="">
                      <Form.Item name="totime">
                        <TimePicker
                          className="w-[202px] md:h-12 h-8 "
                          placeholder="End time"
                          format="h:mm A"
                          // onChange={handleToTime}
                          minuteStep={10}
                          needConfirm={false}
                          showNow={false}
                          allowClear={false}
                          inputReadOnly={true}
                        />
                      </Form.Item>
                    </div>

                    <div className="">
                      <Form.Item
                        name="duration"
                        className="w-[202px] md:h-12 h-8 "
                      >
                        <Select
                          placeholder="duration"
                          // onChange={handleConsDuration}
                          className="w-4/5 md:h-12 h-10 "
                        >
                          {durationArr.map((duration) => (
                            <Select.Option value={duration}>
                              {duration} minutes
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>

                  <div className="flex flex-wrap pl-2 gap-4">
                    <div className="">
                      <div className="">
                        <label className="md:text-lg text-base font-medium">
                          Consultation Type
                        </label>
                        <span className="text-red-500">*</span>
                      </div>
                      <Form.Item name="consultationtype">
                        <Checkbox.Group
                          onChange={handleConsType}
                          value={appointmentTypes}
                        >
                          <Checkbox value="inPerson">In person</Checkbox>
                          <Checkbox value="video">Video</Checkbox>
                          {/* <Checkbox value="homeVisitFee">Home visit</Checkbox> */}
                        </Checkbox.Group>
                      </Form.Item>
                    </div>

                    <div className="my-3">
                      <div className="my-2">
                        {/* <div className="my-2">
                    <label className="md:text-lg text-base font-medium">
                      Video Fee
                    </label>
                    <span className="text-red-500">*</span>
                  </div> */}

                        <Form.Item
                          name="videoFee"
                          rules={[
                            {
                              required: true,
                              message: "Please Enter Total Amount!",
                            },
                          ]}
                        >
                          <Input className="w-[202px]" placeholder="videoFee" />
                        </Form.Item>
                      </div>
                    </div>

                    <div className="my-3">
                      <div className="my-2">
                        {/* <div className="my-2">
                    <label className="md:text-lg text-base font-medium">
                      In-Person Fee
                    </label>
                    <span className="text-red-500">*</span>
                  </div> */}
                        <Form.Item
                          name="inpersonFee"
                          rules={[
                            {
                              required: true,
                              message: "Please Enter Total Amount!",
                            },
                          ]}
                        >
                          <Input
                            className="w-[202px]"
                            placeholder="inpersonFee"
                          />
                        </Form.Item>
                      </div>
                    </div>

                    <div className="my-3">
                      <div className="my-2">
                        {/* <div className="my-2">
                          <label className="md:text-lg text-base font-medium">
                            Home visit
                          </label>
                          <span className="text-red-500">*</span>
                        </div> */}

                        {/* <Form.Item
                          name="homeVisitFee"
                          rules={[
                            {
                              required: true,
                              message: "Please Enter Total Amount!",
                            },
                          ]}
                        >
                          <Input
                            className="w-[202px]"
                            placeholder="Home-visit fee"
                          />
                        </Form.Item> */}
                      </div>
                    </div>
                  </div>

                  <div className=" p-2">
                    <div className=" flex gap-4">
                      <label className="md:text-lg text-base font-medium">
                        Days
                        <span className="text-red-500">*</span>
                      </label>
                    </div>
                    <Form.Item
                      name="daysOfWeek"
                      valuePropName="checked"
                      rules={[
                        {
                          required: true,
                          message: "Please select at least one day!",
                        },
                      ]}
                    >
                      <Checkbox.Group
                        name="checked"
                        onChange={handleDays}
                        value={days}
                      >
                        <div className="w-max text-white flex items-center gap-1">
                          <Checkbox
                            className=""
                            value="all"
                            checked={isChecked}
                            onChange={(e) => setIsChecked(e.target.checked)}
                          >
                            Select all
                          </Checkbox>
                          <Checkbox className="" value="sunday">
                            Sunday
                          </Checkbox>
                          <Checkbox className="" value="monday">
                            Monday
                          </Checkbox>
                          <Checkbox className="" value="tuesday">
                            Tuesday
                          </Checkbox>
                          <Checkbox className="" value="wednesday">
                            Wednesday
                          </Checkbox>
                          <Checkbox className="" value="thursday">
                            Thursday
                          </Checkbox>
                          <Checkbox className="" value="friday">
                            Friday
                          </Checkbox>
                          <Checkbox className="" value="saturday">
                            Saturday
                          </Checkbox>
                        </div>
                      </Checkbox.Group>
                    </Form.Item>
                  </div>

                  <Row gutter={24}>
                    <Col span={24}>
                      <div className={`flex justify-end pr-5 gap-3 `}>
                        <button className="px-2 py-1 bg-white w-20 rounded bg-transparent border shadow">
                          Cancel
                        </button>
                        <button
                          // onClick={saveSlot}
                          htmlType="submit"
                          className="px-2 bg-brand-primaryColor py-1 w-20 rounded text-white "
                        >
                          Save
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
            <p className="mt-3 font-sans font-semibold text-[#333333] text-base ">
              Published Slots :
            </p>
            <div className="font-bold mt-3  shadow-[0_0_10px_rgba(0,0,0,0.15)] rounded-md px-4 py-2  bg-white">
              {savedSlots ? (
                <div className="grid grid-cols-5 gap-1">
                  {savedSlots.map((slot) => (
                    <div
                      key={slot.id}
                      className=" border flex-wrap-reverse rounded-lg  h-[250px]   bg-[#F1FFF9] shadow-md my-2"
                    >
                      <div className="p-3 h-[200px]">
                        <div className="grid grid-cols-2  items-start">
                          <p className="w-28 font-sans text-[#828282] text-xs font-normal">
                            From Date:
                          </p>
                          <p className=" font-sans text-[#333333] text-xs  font-normal">
                            {slot.fromDate}
                          </p>
                        </div>
                        <div className="grid grid-cols-2  items-start">
                          <p className="w-28 font-sans text-[#828282] text-xs font-normal">
                            To Date:
                          </p>
                          <p className=" font-sans text-[#333333] text-xs  font-normal">
                            {slot.toDate}
                          </p>
                        </div>
                        <div className="grid grid-cols-2  items-start ">
                          <p className="w-24 font-sans text-[#828282] text-xs font-normal">
                            Start time:
                          </p>
                          <p className=" font-sans text-[#333333] text-xs  font-normal">
                            {slot.fromTime}
                          </p>
                        </div>
                        <div className=" grid grid-cols-2  items-start">
                          <p className="w-24 font-sans text-[#828282] text-xs font-normal">
                            End time:
                          </p>
                          <p className=" font-sans text-[#333333] text-xs  font-normal">
                            {slot.toTime}
                          </p>
                        </div>
                        <div className="grid grid-cols-2  items-start">
                          <p className="font-sans text-[#828282] text-xs font-normal">
                            Days:
                          </p>
                          <p className="font-sans text-[#333333] text-[11px] font-normal">
                            {[
                              slot.sunday === "Y" && "Sun",
                              slot.monday === "Y" && "Mon",
                              slot.tuesday === "Y" && "Tue",
                              slot.wednesday === "Y" && "Wed",
                              slot.thursday === "Y" && "Thu",
                              slot.friday === "Y" && "Fri",
                              slot.saturday === "Y" && "Sat",
                            ]
                              .filter(Boolean)
                              .join(", ")}
                          </p>
                        </div>

                        <div className="grid grid-cols-2  items-start">
                          <p className="w-28   font-sans font-normal  text-[#828282] text-xs ">
                            Slot Status :
                          </p>

                          <p className="grid-cols-4  font-sans  text-[#333333] text-xs flex  font-normal gap-2 ">
                            Active
                            <Switch
                              className="  h-3"
                              defaultChecked
                              onChange={() => makeSlotInactive(slot)}
                            />
                          </p>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 border-t-2   pl-2 mt-2 ">
                        <p className="w-28 mt-1 font-sans text-[#828282]   font-normal">
                          Created Date :
                        </p>
                        <p className="grid-cols-4 font-sans mt-1  text-[#333333] text-xs flex justify-start  font-normal">
                          {dayjs(slot.createdDate).format("DD/MM/YYYY")}
                        </p>
                        {/* <div className="grid grid-cols-2   items-start">
                          <p className="w-28 mt- font-sans font-normal  text-[#828282] text-xs ">
                            Slot Status :
                          </p>

                          <p className="grid-cols-4 ml-12  font-sans  text-[#333333] text-xs flex  font-normal gap-2 ">
                            Active
                            <Switch
                              className=""
                              defaultChecked
                              onChange={() => makeSlotInactive(slot)}
                            />
                          </p>
                        </div> */}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div>No slots Published Yet </div>
              )}
            </div>
          </div>
        </div>
        {/* patient queue design */}
        {isVerticalOpen ? (
          <Draggable>
            <div className="draggable-container fixed top-1/2 right-2 w-14 transform -translate-y-1/2 z-50">
              <div
                className="hidden md:block relative mb-5 cursor-pointer"
                onClick={closeCircle}
              >
                <IoIosCloseCircle className="hidden md:block absolute text-red-400 mb-1 right-0 top-0" />
              </div>
              <img
                src={patientqueue}
                alt="patientqueue"
                className="cursor-pointer"
                title="Patient Queue"
                onClick={showDrawer}
              />
            </div>
          </Draggable>
        ) : (
          <div
            className="vertical"
            style={{ marginTop: "16rem" }}
            onClick={handleClick}
          >
            <p className="vertical-p">
              <div className="vertical-icon-dashboard">
                <MdKeyboardDoubleArrowUp />
              </div>
              Queue
            </p>
          </div>
        )}

        {isDrawerOpen && (
          <div className="grid justify-end mt-5">
            {isDrawerOpen && <PatientQueue onClose={onClose} />}
          </div>
        )}
      </div>
    </Layouts>
  );
}

export default Slot;
